// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: 6nWKOKTIlw
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Button from "../../Button"; // plasmic-import: CaCG91iQ-xN/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicSubmitExamModal.module.css"; // plasmic-import: 6nWKOKTIlw/css
import Icon12Icon from "./icons/PlasmicIcon__Icon12"; // plasmic-import: LYoK9OD3Rv/icon

createPlasmicElementProxy;

export const PlasmicSubmitExamModal__VariantProps = new Array();

export const PlasmicSubmitExamModal__ArgProps = new Array();

const $$ = {};

function PlasmicSubmitExamModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__zgvWh)}>
        <div className={classNames(projectcss.all, sty.freeBox__whEr)}>
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"Confirmation"}
          </div>
          <Icon12Icon
            data-plasmic-name={"btnClose"}
            data-plasmic-override={overrides.btnClose}
            className={classNames(projectcss.all, sty.btnClose)}
            role={"img"}
          />
        </div>
        <div className={classNames(projectcss.all, sty.freeBox___4E5Ga)}>
          <div
            data-plasmic-name={"error"}
            data-plasmic-override={overrides.error}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.error
            )}
          >
            {"Are you sure you would like to submit now?"}
          </div>
          <Stack__
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__c5H45)}
          >
            <Button
              data-plasmic-name={"btnYes"}
              data-plasmic-override={overrides.btnYes}
              className={classNames("__wab_instance", sty.btnYes)}
              color={"softGreen"}
              submitsForm={true}
            >
              {"Yes"}
            </Button>
            <Button
              data-plasmic-name={"btnNo"}
              data-plasmic-override={overrides.btnNo}
              className={classNames("__wab_instance", sty.btnNo)}
              color={"softRed"}
              submitsForm={true}
            >
              {"No"}
            </Button>
          </Stack__>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "text", "btnClose", "error", "btnYes", "btnNo"],
  text: ["text"],
  btnClose: ["btnClose"],
  error: ["error"],
  btnYes: ["btnYes"],
  btnNo: ["btnNo"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSubmitExamModal__ArgProps,
          internalVariantPropNames: PlasmicSubmitExamModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSubmitExamModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSubmitExamModal";
  } else {
    func.displayName = `PlasmicSubmitExamModal.${nodeName}`;
  }
  return func;
}

export const PlasmicSubmitExamModal = Object.assign(
  // Top-level PlasmicSubmitExamModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    btnClose: makeNodeComponent("btnClose"),
    error: makeNodeComponent("error"),
    btnYes: makeNodeComponent("btnYes"),
    btnNo: makeNodeComponent("btnNo"),
    // Metadata about props expected for PlasmicSubmitExamModal
    internalVariantProps: PlasmicSubmitExamModal__VariantProps,
    internalArgProps: PlasmicSubmitExamModal__ArgProps
  }
);

export default PlasmicSubmitExamModal;
/* prettier-ignore-end */
